<div class="tw-flex tw-flex-row" style="height: 100%;">
    <div class="tw-w-full">
        <mat-tab-group color="primary" animationDuration="0ms" style="height: 100%;" [selectedIndex]="getTabChange" 
            [class.no-selection]="getTabChange === -1"
            (selectedTabChange)="tabPanelChange.emit($event.tab.textLabel)"
        >
            @if(showSales) {
                <mat-tab label="{{'HISTORY.TOPBAR_HISTORY_MODULE.SALES' | translate}}"><ng-content select="[Sales]"></ng-content></mat-tab>
            }
            @if(showEInvoices) {
                <mat-tab label="{{'HISTORY.TOPBAR_HISTORY_MODULE.E_INVOICES' | translate}}"><ng-content select="[eInvoices]"></ng-content></mat-tab>
            }
            @if(showSalesDataSent) {
                <mat-tab label="{{'HISTORY.TOPBAR_HISTORY_MODULE.SALES_DATA_SENT' | translate}}"><ng-content select="[SalesDataSent]"></ng-content></mat-tab>
            }
        </mat-tab-group>
    </div>
</div>
